import { JSXElement, mergeProps, Show } from 'solid-js';
import { AppDataProvider } from '~/components/AppData';
import { WorkspaceApiConnector } from '~/api';
import SkLoader from '~/components/ui/SkLoader';
import { ConfirmModalProvider } from '~/components/ui/Modal';
import FeatureFlagLoader from '~/components/FeatureFlags';
import ResourceContextDataProvider from '~/components/ResourceContextData/ResourceContextData.tsx';
import FSAModalContextProvider from '~/pages/FSAOnboarding/FSAModalContext.tsx';
import PylonWidget from '~/components/PylonWidget/PylonWidget.tsx';

type WorkspaceContainerProps = {
  children: JSXElement;
};

export default function WorkspaceContainer(
  props: WorkspaceContainerProps
): JSXElement {
  const merged = mergeProps({}, props);
  return (
    <WorkspaceApiConnector>
      <ConfirmModalProvider>
        <AppDataProvider>
          {(isDataLoaded) => (
            <Show
              when={isDataLoaded}
              fallback={<SkLoader />}
            >
              <ResourceContextDataProvider>
                <FeatureFlagLoader>
                  <FSAModalContextProvider>
                    <PylonWidget />
                    {merged.children}
                  </FSAModalContextProvider>
                </FeatureFlagLoader>
              </ResourceContextDataProvider>
            </Show>
          )}
        </AppDataProvider>
      </ConfirmModalProvider>
    </WorkspaceApiConnector>
  );
}
